import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import InputField from '../../shared/form-elements/input';
import TextField from '../../shared/form-elements/textarea';
import moment from 'moment';

const Form = ({
	handleSubmit,
	submitForm,
	editId,
	updateConfig,
	dashboardConfigFields,
	intl,
	can
}) => (
	<div className="form-container contest-rule-form">
		<div className="form-container__head">
			<h2>{ intl(editId ? 'Edit rule' : 'Create new rule') }</h2>
		</div>

		<div className="form-container__body">
			<form className="ui-form create-contest-rule" onSubmit={handleSubmit(data => submitForm(data, editId))}>

				<div className="ui-form__element">
					<Field
						name="name"
						placeholder={intl('Name')}
						component={InputField}
					/>
				</div>

				<div className="ui-form__element datepickers_container">
					<Field
						name="starts_at"
						type='datetime-local'
						format={v => v && moment(v).format('YYYY-MM-DDTHH:mm:ss')}
						component={InputField}
						placeholder={intl('Starts at')}
					/>
					<Field
						name="ends_at"
						type='datetime-local'
						format={v => v && moment(v).format('YYYY-MM-DDTHH:mm:ss')}
						component={InputField}
						placeholder={intl('Ends at')}
					/>
				</div>
				{
					dashboardConfigFields.map((item, index) => (
						<div className="ui-form__element" key={index}>
							<Field
								name={item.id}
								placeholder={item.name}
								onChange={() => setTimeout(updateConfig, 300)}
								component={InputField}
							/>
						</div>
					))
				}

				<div className="ui-form__element">
					<Field
						name="config"
						placeholder={intl('Config (JSON)')}
						component={TextField}
					/>
				</div>

				<div className="ui-form__element buttons">
					{can('contestEdit') &&
						<button className="ui-btn ui-btn-primary">
							{intl(!editId ? 'Save' : 'Edit')}
						</button>}
					{<Link to="contests/">
						<button type="button" className="ui-btn ui-btn-cancel">
							{intl('Cancel')}
						</button>
					</Link>}
				</div>
			</form>
		</div>
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	editId: PropTypes.any,
	intl: PropTypes.func,
	can: PropTypes.func
};

const validate = values => {
	const errors = {};
	if (moment(values['starts_at']).isAfter(values['ends_at']) ) {
		errors.starts_at = 'Should be before end of competition';
	}
	return errors;
};

export default reduxForm({
	form: 'contestRulesForm',
	validate
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/contests/components/form.js